module.exports = __webpack_public_path__ + "img/barChart3.3d5afded.svg";